// formUtils.js - Version corrigée qui garantit la génération des erreurs pour les selects

import validationService from "../services/validationService";


export const validateFormStatically = (formData) => {
    const errors = {};
    let hasErrors = false;

    // Fonction d'aide pour vérifier et ajouter des erreurs
    // const addError = (field, message) => {
    //     errors[field] = message;
    //     hasErrors = true;
    //     console.log(`Erreur ajoutée: ${field} = ${message}`);
    // };

    // // === VALIDATION DE TOUS LES CHAMPS EN MÊME TEMPS ===
    // // Civilité
    // if (!formData.civilite || formData.civilite.trim() === '') {
    //     addError('civilite', 'Veuillez sélectionner votre civilité');
    // }

    // // Ville
    // if (!formData.ville || formData.ville.trim() === '') {
    //     addError('ville', 'Veuillez sélectionner votre ville');
    // }

    // // Point de service
    // if (!formData.pointService || formData.pointService.trim() === '') {
    //     addError('pointService', 'Veuillez sélectionner un point de service');
    // }

    // // Canal de réponse
    // if (!formData.canalReponse || formData.canalReponse.trim() === '') {
    //     addError('canalReponse', 'Veuillez sélectionner un canal de réponse');
    // }

    // // Catégorie
    // if (!formData.categorie || formData.categorie.trim() === '') {
    //     addError('categorie', 'Veuillez sélectionner une catégorie');
    // }

    // // Élément
    // if (!formData.element || formData.element.trim() === '') {
    //     addError('element', 'Veuillez sélectionner un élément');
    // }

    // // --- Champs texte ---

    // // Nom
    // if (!formData.nom) {
    //     addError('nom', 'Le nom est requis');
    // } else if (formData.nom.length < 2 || formData.nom.length > 50) {
    //     addError('nom', 'Le nom doit contenir entre 2 et 50 caractères');
    // } else if (!/^[a-zA-ZÀ-ÿ\s-']+$/.test(formData.nom)) {
    //     addError('nom', 'Le nom ne doit contenir que des lettres, espaces, tirets et apostrophes');
    // }

    // // Prénom
    // if (!formData.prenom) {
    //     addError('prenom', 'Le prénom est requis');
    // } else if (formData.prenom.length < 2 || formData.prenom.length > 50) {
    //     addError('prenom', 'Le prénom doit contenir entre 2 et 50 caractères');
    // } else if (!/^[a-zA-ZÀ-ÿ\s-']+$/.test(formData.prenom)) {
    //     addError('prenom', 'Le prénom ne doit contenir que des lettres, espaces, tirets et apostrophes');
    // }

    // // Email
    // const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    // if (!formData.email) {
    //     addError('email', 'L\'email est requis');
    // } else if (!emailRegex.test(formData.email) || formData.email.length > 100) {
    //     addError('email', 'Veuillez entrer une adresse email valide (max 100 caractères)');
    // }

    // // Confirmation Email
    // if (!formData.emailConfirm) {
    //     addError('emailConfirm', 'La confirmation de l\'email est requise');
    // } else if (formData.email !== formData.emailConfirm) {
    //     addError('emailConfirm', 'Les adresses email ne correspondent pas');
    // }

    // // Téléphone
    // const phoneRegex = /^(\+221|00221)?(7[0-9]{8})$/;
    // if (!formData.telephone) {
    //     addError('telephone', 'Le numéro de téléphone est requis');
    // } else if (!phoneRegex.test(formData.telephone)) {
    //     addError('telephone', 'Format invalide. Le numéro doit commencer par 7 et contenir 9 chiffres');
    // }

    // // Numéro de compte
    // const accountRegex = /^[A-Z0-9]{11,34}$/;
    // if (!formData.numeroCompte) {
    //     addError('numeroCompte', 'Le numéro de compte est requis');
    // } else if (!accountRegex.test(formData.numeroCompte)) {
    //     addError('numeroCompte', 'Le numéro de compte doit contenir entre 11 et 34 caractères alphanumériques');
    // }

    // // Objet de la plainte
    // if (!formData.objetPlainte) {
    //     addError('objetPlainte', 'L\'objet de la plainte est requis');
    // } else if (formData.objetPlainte.trim().length < 10) {
    //     addError('objetPlainte', 'L\'objet de la plainte doit contenir au moins 10 caractères');
    // } else if (formData.objetPlainte.trim().length > 200) {
    //     addError('objetPlainte', 'L\'objet de la plainte ne doit pas dépasser 200 caractères');
    // }

    // // Lieu Incident
    // if (formData.lieuIncident && formData.lieuIncident.trim().length < 5) {
    //     addError('lieuIncident', 'Si renseigné, le lieu doit contenir au moins 5 caractères');
    // }

    // // Montant réclamé
    // if (formData.montantReclame) {
    //     const montant = parseFloat(formData.montantReclame);
    //     if (isNaN(montant)) {
    //         addError('montantReclame', 'Veuillez entrer un montant valide');
    //     } else if (montant <= 0) {
    //         addError('montantReclame', 'Le montant doit être supérieur à 0');
    //     } else if (montant > 100000000) {
    //         addError('montantReclame', 'Le montant semble anormalement élevé (max 100 millions)');
    //     }
    // }

    // // Date incident
    // if (!formData.dateIncident) {
    //     addError('dateIncident', 'La date de l\'incident est requise');
    // } else {
    //     const incidentDate = new Date(formData.dateIncident);
    //     const currentDate = new Date();

    //     if (incidentDate > currentDate) {
    //         addError('dateIncident', 'La date ne peut pas être dans le futur');
    //     }
    // }

    // // Description
    // if (!formData.description) {
    //     addError('description', 'La description est requise');
    // } else if (formData.description.trim().length < 20) {
    //     addError('description', 'La description doit contenir au moins 20 caractères');
    // } else if (formData.description.trim().length > 2000) {
    //     addError('description', 'La description ne doit pas dépasser 2000 caractères');
    // }

    // // Attente
    // if (!formData.attente) {
    //     addError('attente', 'Veuillez préciser vos attentes');
    // } else if (formData.attente.trim().length < 10) {
    //     addError('attente', 'Vos attentes doivent contenir au moins 10 caractères');
    // } else if (formData.attente.trim().length > 1000) {
    //     addError('attente', 'Vos attentes ne doivent pas dépasser 1000 caractères');
    // }

    return [!hasErrors, errors];
};

export const validateForm = async (formData) => {
    try {
        // Validation uniquement dynamique (backend)
        const dynamicErrors = await validationService.validateForm(formData);

        // Si des erreurs dynamiques sont détectées
        if (dynamicErrors && Object.keys(dynamicErrors).length > 0) {
            console.log("Erreurs de validation à afficher:", dynamicErrors);
            return [false, dynamicErrors];
        }

        // Si aucune erreur n'est détectée
        return [true, {}];
    } catch (error) {
        console.error('Erreur lors de la validation:', error);
        return [false, {
            submit: error.message || "Une erreur est survenue lors de la validation du formulaire"
        }];
    }
};



export const generateTrackingNumber = () => {
    const date = new Date();
    const year = date.getFullYear().toString().slice(-2);
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const day = date.getDate().toString().padStart(2, '0');
    const random = Math.floor(1000 + Math.random() * 9000);
    return `REC-${year}${month}${day}-${random}`;
};